import './Cards.css';
import { AddCard } from '../components/AddCard/AddCard';
import { CardsContent } from '../components/Content/CardsContent';
import RequisiteContainer from '../../../../components/RequisiteContainer';
import { useGetSelfQuery } from 'redux/services/TraderApi';
import { Loading } from 'components/Loading/Loading';
import { FormProvider, useForm } from 'react-hook-form';
import { IInputs } from '../components/AddCard/types';

export const Cards = () => {
  const { data: _, isLoading } = useGetSelfQuery(undefined, { pollingInterval: 10000 });
  const formMethods = useForm<IInputs>({ defaultValues: { bankName: '' } });

  return isLoading ? (
    <Loading />
  ) : (
    <RequisiteContainer>
      <FormProvider {...formMethods}>
        <div className={'cards'} style={{ height: '100%', position: 'relative' }}>
          <h3 className={'card_title'}> Реквизиты</h3>
          <AddCard />
          <CardsContent />
        </div>
      </FormProvider>
    </RequisiteContainer>
  );
};
